tinymce.addI18n("eu", {
    "#": "#",
    "Accessibility": "Irisgarritasuna",
    "Accordion": "Akordeoia",
    "Accordion body...": "Akordeoi-gorputza...",
    "Accordion summary...": "Akordeoi-laburpena...",
    "Action": "Ekintza",
    "Activity": "Jarduera",
    "Address": "Helbidea",
    "Advanced": "Aurreratua",
    "Align": "Lerrokatu",
    "Align center": "Lerrokatu erdian",
    "Align left": "Lerrokatu ezkerrean",
    "Align right": "Lerrokatu eskuinean",
    "Alignment": "Lerrokatzea",
    "Alignment {0}": "Lerrokatzea: {0}",
    "All": "Guztiak",
    "Alternative description": "Ordezko deskribapena",
    "Alternative source": "Ordezko jatorria",
    "Alternative source URL": "Ordezko jatorriaren URLa",
    "Anchor": "Aingura",
    "Anchor...": "Aingura...",
    "Anchors": "Aingurak",
    "Animals and Nature": "Animaliak eta natura",
    "Arrows": "Geziak",
    "B": "B",
    "Background color": "Atzeko planoaren kolorea",
    "Background color {0}": "Atzeko planoaren kolorea: {0}",
    "Black": "Beltza",
    "Block": "Blokea",
    "Block {0}": "{0} blokea",
    "Blockquote": "Zita bat egiteko blokea (blockquote)",
    "Blocks": "Blokeak",
    "Blue": "Urdina",
    "Blue component": "Osagai urdina",
    "Body": "Gorputza",
    "Bold": "Lodia",
    "Border": "Ertza",
    "Border color": "Ertzaren kolorea",
    "Border style": "Ertzaren estiloa",
    "Border width": "Ertzaren zabalera",
    "Bottom": "Behean",
    "Browse files": "Arakatu fitxategiak",
    "Browse for an image": "Arakatu irudi baten bila",
    "Browse links": "Arakatu estekak",
    "Bullet list": "Bulet zerrenda",
    "Cancel": "Utzi",
    "Caption": "Irudi-oina",
    "Cell": "Gelaxka",
    "Cell padding": "Gelaxken betegarria",
    "Cell properties": "Gelaxkaren propietateak",
    "Cell spacing": "Gelaxka arteko tartea",
    "Cell styles": "Gelaxkaren estiloak",
    "Cell type": "Gelaxka mota",
    "Center": "Erdia",
    "Characters": "Karaktereak",
    "Characters (no spaces)": "Karaktereak (espaziorik gabe)",
    "Circle": "Zirkulua",
    "Class": "Klasea",
    "Clear formatting": "Garbitu formatua",
    "Close": "Itxi",
    "Code": "Kodea",
    "Code sample...": "Kode adibidea...",
    "Code view": "Ikusi kodea",
    "Color Picker": "Kolore-hautatzailea",
    "Color swatch": "Koloreak",
    "Cols": "Zutabeak",
    "Column": "Zutabea",
    "Column clipboard actions": "Zutabearen arbeleko ekintzak",
    "Column group": "Zutabe taldea",
    "Column header": "Zutabearen goiburua",
    "Constrain proportions": "Mugatu proportzioak",
    "Copy": "Kopiatu",
    "Copy column": "Kopiatu zutabea",
    "Copy row": "Kopiatu errenkada",
    "Could not find the specified string.": "Ezin izan da zehaztutako katea aurkitu.",
    "Could not load emojis": "Ezin izan dira emojiak kargatu",
    "Count": "Zenbatu",
    "Currency": "Moneta",
    "Current window": "Leiho berean",
    "Custom color": "Kolore pertsonalizatua",
    "Custom...": "Pertsonalizatu...",
    "Cut": "Ebaki",
    "Cut column": "Ebaki zutabea",
    "Cut row": "Ebaki errenkada",
    "Dark Blue": "Urdin iluna",
    "Dark Gray": "Gris iluna",
    "Dark Green": "Berde iluna",
    "Dark Orange": "Laranja iluna",
    "Dark Purple": "More iluna",
    "Dark Red": "Gorri iluna",
    "Dark Turquoise": "Turkesa iluna",
    "Dark Yellow": "Hori iluna",
    "Dashed": "Marrekin",
    "Date/time": "Data/ordua",
    "Decrease indent": "Txikitu koska",
    "Default": "Lehenetsita",
    "Delete accordion": "Ezabatu akordeoia",
    "Delete column": "Ezabatu zutabea",
    "Delete row": "Ezabatu errenkada",
    "Delete table": "Ezabatu taula",
    "Dimensions": "Neurriak",
    "Disc": "Diskoa",
    "Div": "Div",
    "Document": "Dokumentua",
    "Dotted": "Puntuekin",
    "Double": "Bikoitza",
    "Drop an image here": "Ekarri irudia hona",
    "Dropped file type is not supported": "Jaregindako fitxategi mota ez da onartzen",
    "Edit": "Editatu",
    "Embed": "Enbotatzea",
    "Emojis": "Emojiak",
    "Emojis...": "Emojiak...",
    "Error": "Errorea",
    "Error: Form submit field collision.": "Errorea: formularioaren eremuetan talka gertatu da.",
    "Error: No form element found.": "Errorea: ez da formularioaren elementurik aurkitu.",
    "Extended Latin": "Latin zabaldua",
    "Failed to initialize plugin: {0}": "Errorea plugina abiaraztean: {0}",
    "Failed to load plugin url: {0}": "Errorea gertatu da pluginaren URLa kargatzean: {0}",
    "Failed to load plugin: {0} from url {1}": "Errorea {0} plugina {1} URLtik kargatzean",
    "Failed to upload image: {0}": "Errorea irudia igotzean: {0}",
    "File": "Fitxategia",
    "Find": "Bilatu",
    "Find (if searchreplace plugin activated)": "Bilatu (bilatu-ordezkatu plugina aktibatuta badago)",
    "Find and Replace": "Bilatu eta ordezkatu",
    "Find and replace...": "Bilatu eta ordezkatu...",
    "Find in selection": "Bilatu hautapenean",
    "Find whole words only": "Bilatu soilik hitz osoak",
    "Flags": "Banderak",
    "Focus to contextual toolbar": "Fokua testuinguruko tresna-barrara eraman",
    "Focus to element path": "Fokua elementuaren bidera eraman",
    "Focus to menubar": "Fokua menu-barrara eraman",
    "Focus to toolbar": "Fokoa tresna-barrara eraman",
    "Font": "Letra-mota",
    "Font size {0}": "{0} letra-tamaina",
    "Font sizes": "Letra tamainak",
    "Font {0}": "{0} letra-mota",
    "Fonts": "Letra-motak",
    "Food and Drink": "Janari eta edaria",
    "Footer": "Oina",
    "Format": "Formatua",
    "Format {0}": "{0} formatua",
    "Formats": "Formatuak",
    "Fullscreen": "Pantaila osoa",
    "G": "G",
    "General": "Orokorra",
    "Gray": "Grisa",
    "Green": "Berdea",
    "Green component": "Osagai berdea",
    "Groove": "Ildaskatua",
    "Handy Shortcuts": "Laster-tekla erabilgarriak",
    "Header": "Goiburua",
    "Header cell": "Goiburuko gelaxka",
    "Heading 1": "1. goiburua",
    "Heading 2": "2. goiburua",
    "Heading 3": "3. goiburua",
    "Heading 4": "4. goiburua",
    "Heading 5": "5. goiburua",
    "Heading 6": "6. goiburua",
    "Headings": "Izenburuak",
    "Height": "Altuera",
    "Help": "Laguntza",
    "Hex color code": "Kolore-kode hamaseitarra",
    "Hidden": "Ezkutua",
    "Horizontal align": "Lerrokatze horizontala",
    "Horizontal line": "Marra horizontala",
    "Horizontal space": "Hutsune horizontala",
    "ID": "IDa",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "IDa hizki batekin hasi behar da, eta jarraian hizki gehiago, zenbakiak, marrak, puntuak komak edo azpiko marrak izan ditzake soilik.",
    "Image is decorative": "Irudia apaingarria da",
    "Image list": "Irudi zerrenda",
    "Image title": "Irudiaren izenburua",
    "Image...": "Irudia...",
    "ImageProxy HTTP error: Could not find Image Proxy": "Irudi proxiaren HTTP errorea: ezin izan da irudi proxia aurkitu",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Irudi proxiaren HTTP errorea: irudi proxiaren URLa ez da zuzena",
    "ImageProxy HTTP error: Rejected request": "Irudi proxiaren HTTP errorea: eskaera baztertu egin da",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Irudi proxiaren HTTP errorea: errore ezezaguna",
    "Increase indent": "Handitu koska",
    "Inline": "Txertatuta",
    "Insert": "Txertatu",
    "Insert Template": "Txertatu txantiloia",
    "Insert accordion": "Txertatu akordeoia",
    "Insert column after": "Txertatu zutabea ostean",
    "Insert column before": "Txertatu zutabea aurretik",
    "Insert date/time": "Txertatu data/ordua",
    "Insert image": "Txertatu irudia",
    "Insert link (if link plugin activated)": "Txertatu esteka (esteka plugina aktibatuta badago)",
    "Insert row after": "Txertatu errenkada ostean",
    "Insert row before": "Txertatu errenkada aurretik",
    "Insert table": "Txertatu taula",
    "Insert template...": "Txertatu txantiloia...",
    "Insert video": "Txertatu bideoa",
    "Insert/Edit code sample": "Txertatu/Editatu kode adibidea",
    "Insert/edit image": "Txertatu/editatu irudia",
    "Insert/edit link": "Txertatu/editatu esteka",
    "Insert/edit media": "Txertatu/editatu multimedia",
    "Insert/edit video": "Txertatu/editatu bideoa",
    "Inset": "Barruko marra",
    "Invalid hex color code: {0}": "Kolore-kode hamaseitarra ez da zuzena: {0}",
    "Invalid input": "Sarrera ez da zuzena",
    "Italic": "Etzana",
    "Justify": "Justifikatuta",
    "Keyboard Navigation": "Teklatuaren bidezko nabigazioa",
    "Language": "Hizkuntza",
    "Learn more...": "Ikasi gehiago...",
    "Left": "Ezkerra",
    "Left to right": "Ezkerretik eskuinera",
    "Light Blue": "Urdin argia",
    "Light Gray": "Gris argia",
    "Light Green": "Berde argia",
    "Light Purple": "More argia",
    "Light Red": "Gorri argia",
    "Light Yellow": "Hori argia",
    "Line height": "Lerroaren altuera",
    "Link list": "Esteken zerrenda",
    "Link...": "Esteka...",
    "List Properties": "Zerrendaren Ezaugarriak",
    "List properties...": "Zerrendaren ezaugarriak...",
    "Loading emojis...": "Emojiak kargatzen...",
    "Loading...": "Kargatzen...",
    "Lower Alpha": "Behe alfa",
    "Lower Greek": "Behe grekoa",
    "Lower Roman": "Behe erromatarra",
    "Match case": "Maiuskula/minuskula",
    "Mathematical": "Matematika",
    "Media poster (Image URL)": "Multimedia posterra (irudiaren URLa)",
    "Media...": "Multimedia...",
    "Medium Blue": "Tarteko urdina",
    "Medium Gray": "Tarteko grisa",
    "Medium Purple": "Tarteko morea",
    "Merge cells": "Batu gelaxkak",
    "Middle": "Erdian",
    "Midnight Blue": "Gauerdiko urdina",
    "More...": "Gehiago...",
    "Name": "Izena",
    "Navy Blue": "Itsas-urdina",
    "New document": "Dokumentu berria",
    "New window": "Leiho berria",
    "Next": "Hurrengoa",
    "No": "Ez",
    "No alignment": "Lerrokatzerik ez",
    "No color": "Kolorerik ez",
    "Nonbreaking space": "Zuriune zatiezina",
    "None": "Bat ere ez",
    "Numbered list": "Zenbaki-zerrenda",
    "OR": "EDO",
    "Objects": "Objektuak",
    "Ok": "Ados",
    "Open help dialog": "Ireki laguntza-mezua",
    "Open link": "Ireki esteka",
    "Open link in...": "Ireki esteka hemen...",
    "Open popup menu for split buttons": "Ireki leiho-menua banatze-botoientzat",
    "Orange": "Laranja",
    "Outset": "Kanpoko marra",
    "Page break": "Orrialde-jauzia",
    "Paragraph": "Paragrafoa",
    "Paste": "Itsatsi",
    "Paste as text": "Itsatsi testu bezala",
    "Paste column after": "Itsatsi zutabea ostean",
    "Paste column before": "Itsatsi zutabea aurretik",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Itsastea testu formatu arruntean egingo da orain. Edukiak testu arrunt moduan txertatuko dira aukera hau aldatu bitartean.",
    "Paste or type a link": "Itsatsi edo idatzi esteka",
    "Paste row after": "Itsatsi errenkada ostean",
    "Paste row before": "Itsatsi errenkada aurretik",
    "Paste your embed code below:": "Itsatsi azpian enbotatu beharreko zure kodea:",
    "People": "Jendea",
    "Plugins": "Pluginak",
    "Plugins installed ({0}):": "Instalatutako pluginak ({0}):",
    "Powered by {0}": "Garatzailea: {0}",
    "Pre": "Pre",
    "Preferences": "Hobespenak",
    "Preformatted": "Aurrez formateatuta",
    "Premium plugins:": "Premium pluginak:",
    "Press the Up and Down arrow keys to resize the editor.": "Sakatu gora eta behera egiteko gezi-teklak editorearen tamaina aldatzeko.",
    "Press the arrow keys to resize the editor.": "Sakatu gezi-teklak editorearen tamaina aldatzeko.",
    "Press {0} for help": "Sakatu {0} laguntza lortzeko",
    "Preview": "Aurrebista",
    "Previous": "Aurrekoa",
    "Print": "Inprimatu",
    "Print...": "Inprimatu...",
    "Purple": "Morea",
    "Quotations": "Aipuak",
    "R": "R",
    "Range 0 to 255": "0-tik 255erako zenbakia",
    "Red": "Gorria",
    "Red component": "Osagai gorria",
    "Redo": "Berregin",
    "Remove": "Kendu",
    "Remove color": "Kendu kolorea",
    "Remove link": "Kendu esteka",
    "Replace": "Ordeztu",
    "Replace all": "Ordeztu guztiak",
    "Replace with": "Ordeztu honekin",
    "Resize": "Aldatu tamaina",
    "Restore last draft": "Leheneratu azken zirriborroa",
    "Reveal or hide additional toolbar items": "Erakutsi edo ezkutatu tresna-barrako elementu osagarriak",
    "Rich Text Area": "Testu Aberastun Eremua",
    "Rich Text Area. Press ALT-0 for help.": "Testu Aberastun Eremua. Sakatu ALT-0 laguntza lortzeko.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Testu Aberastun Eremua. Sakatu ALT-F9 menurako. Sakatu ALT-F10 tresna-barrarako. Sakatu ALT-0 laguntzarako",
    "Ridge": "Koska",
    "Right": "Eskuina",
    "Right to left": "Eskuinetik ezkerrera",
    "Row": "Errenkada",
    "Row clipboard actions": "Errenkadaren arbeleko ekintzak",
    "Row group": "Errenkada taldea",
    "Row header": "Errenkadaren goiburua",
    "Row properties": "Errenkadaren propietateak",
    "Row type": "Errenkada mota",
    "Rows": "Errenkadak",
    "Save": "Gorde",
    "Save (if save plugin activated)": "Gorde (gordetzeko plugina aktibatuta badago)",
    "Scope": "Esparrua",
    "Search": "Bilatu",
    "Select all": "Aukeratu dena",
    "Select...": "Aukeratu...",
    "Selection": "Aukeraketa",
    "Shortcut": "Laster tekla",
    "Show blocks": "Erakutsi blokeak",
    "Show caption": "Erakutsi irudi-oina",
    "Show invisible characters": "Erakutsi karaktere ezkutuak",
    "Size": "Tamaina",
    "Solid": "Solidoa",
    "Source": "Iturburua",
    "Source code": "Iturburu-kodea",
    "Special Character": "Karaktere Berezia",
    "Special character...": "Karaktere berezia...",
    "Split cell": "Banatu gelaxka",
    "Square": "Karratua",
    "Start list at number": "Hasi zerrenda zenbaki batean",
    "Strikethrough": "Marratua",
    "Style": "Estiloa",
    "Subscript": "Azpiindizea",
    "Superscript": "Goi-indizea",
    "Switch to or from fullscreen mode": "Aldatu pantaila osoko modura edo handik itzuli",
    "Symbols": "Ikurrak",
    "System Font": "Sistemaren letra-mota",
    "Table": "Taula",
    "Table caption": "Taularen deskribapena",
    "Table properties": "Taularen propietateak",
    "Table styles": "Taularen estiloak",
    "Template": "Txantiloia",
    "Templates": "Txantiloiak",
    "Text": "Testua",
    "Text color": "Testuaren kolorea",
    "Text color {0}": "Testuaren kolorea: {0}",
    "Text to display": "Bistaratzeko testua",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Sartu duzun URLa helbide elektroniko bat dela dirudi. Nahi duzu dagokion mailto: aurrizkia gehitzea?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Sartu duzun URLa kanpoko esteka bat dela dirudi. Nahi duzu dagokion http:// aurrizkia gehitzea?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Sartu duzun URLa kanpoko esteka bat dela dirudi. Nahi duzu dagokion https:// aurrizkia gehitzea?",
    "Title": "Izenburua",
    "To open the popup, press Shift+Enter": "Leiho berria irekitzeko, sakatu Shift+Enter",
    "Toggle accordion": "Aktibatu/Desaktibatu akordeoia",
    "Tools": "Tresnak",
    "Top": "Goian",
    "Travel and Places": "Bidaiak eta lekuak",
    "Turquoise": "Turkesa",
    "Underline": "Azpimarratua",
    "Undo": "Desegin",
    "Upload": "Kargatu",
    "Uploading image": "Irudia kargatzen",
    "Upper Alpha": "Goi alfa",
    "Upper Roman": "Goi erromatarra",
    "Url": "URLa",
    "User Defined": "Erabiltzaileak definituta",
    "Valid": "Zuzena",
    "Version": "Bertsioa",
    "Vertical align": "Lerrokatze bertikala",
    "Vertical space": "Hutsune bertikala",
    "View": "Ikusi",
    "Visual aids": "Laguntza bisualak",
    "Warn": "Oharra",
    "White": "Zuria",
    "Width": "Zabalera",
    "Word count": "Hitz-kontagailua",
    "Words": "Hitzak",
    "Words: {0}": "Hitzak: {0}",
    "Yellow": "Horia",
    "Yes": "Bai",
    "You are using {0}": "{0} erabiltzen ari zara",
    "You have unsaved changes are you sure you want to navigate away?": "Gorde gabeko aldaketak dituzu, ziur zaude hemendik irten nahi duzula?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Zure nabigatzaileak ez du arbela zuzenean erabiltzeko euskarririk. Mesedez erabili CTRL+X/C/V teklatuko lasterbideak.",
    "alignment": "lerrokatzea",
    "austral sign": "australaren ikurra",
    "cedi sign": "cediaren ikurra",
    "colon sign": "bi puntuen ikurra",
    "cruzeiro sign": "cruzeiroaren ikurra",
    "currency sign": "monetaren ikurra",
    "dollar sign": "dolarraren ikurra",
    "dong sign": "dongaren ikurra",
    "drachma sign": "drakmaren ikurra",
    "euro-currency sign": "euroaren ikurra",
    "example": "adibidea",
    "formatting": "formatua ematen",
    "french franc sign": "libera frantsesaren ikurra",
    "german penny symbol": "alemaniako peniaren ikurra",
    "guarani sign": "guaraniaren ikurra",
    "history": "historia",
    "hryvnia sign": "hryvniaren ikurra",
    "indentation": "koska",
    "indian rupee sign": "indiako rupiaren ikurra",
    "kip sign": "kiparen ikurra",
    "lira sign": "liraren ikurra",
    "livre tournois sign": "libre tournoisaren ikurra",
    "manat sign": "manataren ikurra",
    "mill sign": "millaren ikurra",
    "naira sign": "naira ikurra",
    "new sheqel sign": "sheqel berriaren ikurra",
    "nordic mark sign": "iparraldeko markoaren ikurra",
    "peseta sign": "pezetaren ikurra",
    "peso sign": "pesoaren ikurra",
    "ruble sign": "rubloaren ikurra",
    "rupee sign": "rupiaren ikurra",
    "spesmilo sign": "spesmiloaren ikurra",
    "styles": "estiloak",
    "tenge sign": "tengearen ikurra",
    "tugrik sign": "tugrikaren ikurra",
    "turkish lira sign": "lira turkiarraren ikurra",
    "won sign": "wonaren ikurra",
    "yen character": "yenaren karakterea",
    "yen/yuan character variant one": "yen/yuan karakterearen 1go bariantea",
    "yuan character": "yuanaren karakterea",
    "yuan character, in hong kong and taiwan": "yuanaren karakterea, hong kong eta taiwanen",
    "{0} characters": "{0} karaktere",
    "{0} columns, {1} rows": "{0} zutabe, {1} errenkada",
    "{0} words": "{0} hitz"
});